"use strict";
import { useCallback, useEffect, useRef } from "react";
export function useEvent(event) {
  const eventRef = useRef(event);
  useEffect(() => {
    eventRef.current = event;
  }, [event]);
  return useCallback((...args) => {
    var _a;
    return (_a = eventRef.current) == null ? void 0 : _a.call(eventRef, ...args);
  }, []);
}
